import { FormFieldType } from "@/enums";
import { isTextForm } from "@/lib/utils";
import { useState } from "react";
export function useFieldState(onChange, fieldType, settings, values, value) {
    const [internalValue, setInternalValue] = useState(value || "");
    function onCheckedChange(checked) {
        onChange({
            has_value: true,
            id: settings.id,
            name: settings.name,
            order: settings.order,
            value: checked,
            is_child: settings.is_child,
            parent_id: settings.parent_id,
            $t: "CheckboxFormFieldResult",
        }, `${checked}`);
        setInternalValue(`${checked}`);
    }
    function onInputChange(event) {
        if (isTextForm(fieldType)) {
            const textResult = {
                type: fieldType,
                has_value: true,
                id: settings.id,
                name: settings.name,
                order: settings.order,
                value: event.target.value,
                is_child: settings.is_child,
                parent_id: settings.parent_id,
                $t: "TextFormFieldResult",
            };
            onChange(textResult, event.target.value);
        }
        else if (fieldType === FormFieldType.Mask) {
            onChange({
                has_value: true,
                id: settings.id,
                name: settings.name,
                order: settings.order,
                value: event.target.value,
                is_child: settings.is_child,
                parent_id: settings.parent_id,
                $t: "MaskFormFieldResult",
            }, event.target.value);
        }
        setInternalValue(event.target.value);
    }
    function onTextAreaChanged(event) {
        setInternalValue(event.target.value);
        onChange({
            type: fieldType,
            has_value: true,
            id: settings.id,
            name: settings.name,
            order: settings.order,
            value: event.target.value,
            is_child: settings.is_child,
            parent_id: settings.parent_id,
            $t: "TextFormFieldResult",
        }, event.target.value);
    }
    function onSelectChange(value) {
        setInternalValue(value);
        onChange({
            type: fieldType,
            has_value: true,
            id: settings.id,
            name: settings.name,
            order: settings.order,
            is_child: settings.is_child,
            parent_id: settings.parent_id,
            values: Object.values(values),
            selected_value: value,
            $t: "SelectFormFieldResult",
        }, value);
    }
    return {
        internalValue,
        onInputChange,
        onTextAreaChanged,
        onSelectChange,
        onCheckedChange,
    };
}
//# sourceMappingURL=useFieldState.js.map